module.exports = __webpack_public_path__ + "img/切换.650945e2.svg";